import { render, staticRenderFns } from "./favorites-vacancies.vue?vue&type=template&id=1a2abf6d&lang=html&"
import script from "./favorites-vacancies.vue?vue&type=script&lang=js&"
export * from "./favorites-vacancies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports